import React from "react";

const DocumentUploadQuestion = ({ DocumentQuestion, onEdit }) => {
    return (
        <div className="document-upload-question">
            <div className="bizzie-icon-chat">
                <img src="/images/chatbot-icon.png" alt="chatbot" />
            </div>
            <div className="document-upload-question-content">
                <div className="document-upload-question-content-title">
                    {DocumentQuestion}
                    {onEdit && (
                        <span className="edit-icon" onClick={onEdit}>
                            <img src="/images/edit-icon.png" alt="edit" style={{ marginLeft: "10px", cursor: "pointer" }} />
                        </span>
                    )}
                </div>
                <div className="document-upload-question-content-type">
                    (JPEG, JPG, PNG, PDF | Max 10MB)
                </div>
            </div>
        </div>
    );
};

export default DocumentUploadQuestion;